import React from "react";
import { BordonaAppBar } from "./BordonaAppBar";
import { AmbientGlow } from "../home/AmbientGlow";
import { StellarDust } from "../home/StellarDust";
import { HOME_THEME as T } from "../../lib/homeTheme";

interface HomeLayoutProps {
  children: React.ReactNode;
  /** Estudio inmersivo: sin AppBar global (el chrome lo pone la sesión). */
  hideAppBar?: boolean;
}

export const HomeLayout: React.FC<HomeLayoutProps> = ({ children, hideAppBar = false }) => {
  return (
    <div className="relative h-screen w-screen overflow-hidden" style={{ backgroundColor: T.bg, color: T.text }}>
      <AmbientGlow />
      <StellarDust />
      {!hideAppBar && <BordonaAppBar />}
      <div className="relative z-10 h-full overflow-y-auto">{children}</div>
    </div>
  );
};

export default HomeLayout;
